// extracted by mini-css-extract-plugin
module.exports = {"row":"EditableRow_row__yhozH","overflow":"EditableRow_overflow__3PXbw"};